import { ApplicationSettingsComponent } from './components/application-settings/application-settings.component'
import { ApplicationSettingsContainerComponent } from './components/application-settings-container.component'
import { ApplicationSettingsNgrxModule } from './application-settings-ngrx.module'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { NotificationProfilesComponent } from './components/notification-profiles/notification-profiles.component'
import { PermissionProfilesComponent } from './components/permission-profiles/permission-profiles.component'
import { RateCardFieldsModalComponent } from './components/rate-card-fields-modal/rate-card-fields-modal.component'
import { RouterModule } from '@angular/router'
import { ScopeUiInputComponent } from '@app/shared/components/ui-components/scope-ui-input/scope-ui-input.component'
import { ScopeUiOptionsMenuComponent } from '@app/shared/components/scope-ui-options-menu/scope-ui-options-menu.component'
import { ScopeUiToggleComponent } from '@app/shared/components/ui-components/scope-ui-toggle/scope-ui-toggle.component'
import { SharedModule } from '@app/shared/shared.module'
import { SortByOrderPipe } from '@app/shared/pipe/sort-by-order.pipe'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SortByOrderPipe,
    ApplicationSettingsNgrxModule,
    ScopeUiOptionsMenuComponent,
    ScopeUiInputComponent,
    ScopeUiToggleComponent,
  ],
  declarations: [
    ApplicationSettingsContainerComponent,
    ApplicationSettingsComponent,
    NotificationProfilesComponent,
    PermissionProfilesComponent,
    RateCardFieldsModalComponent,
  ],
  providers: [],
  exports: [RouterModule, ApplicationSettingsContainerComponent],
})
export class ApplicationSettingsModule {}
